import { Component, Input } from '@angular/core';
import { Router } from "@angular/router";
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ClaimDto } from 'src/app/auto-generated-server-dtos/adjuster/claim/claim-dto';
import { DeleteClaimServiceService } from 'src/app/repair-centre/delete-claim/services/delete-claim-service.service';
import { SetIsClaimTestDataService } from '../../is-claim-test-data/set-is-claim-test-data.service';

@Component({
  selector: 'app-adjuster-delete-claim-modal',
  templateUrl: './adjuster-delete-claim-modal.component.html',
  styleUrl: './adjuster-delete-claim-modal.component.scss'
})
export class AdjusterDeleteClaimModalComponent {
  @Input() claimDto!: ClaimDto;
  isBusyDeleting: boolean = false;
  isBusyTestData: boolean = false;
  showSuccess: boolean = false;

  constructor(
      private deleteClaimService: DeleteClaimServiceService, 
      private setIsClaimTestDataService: SetIsClaimTestDataService, 
      private router: Router,
      public activeModal: NgbActiveModal
  ) {
  }
  
  adjusterDeleteClaim() {
    this.isBusyDeleting = true;
    this.deleteClaimService.DeleteClaim(this.claimDto.claimId).subscribe({
      next: () => {
        this.isBusyDeleting = false; 
        this.claimDto.status = 'Deleted';
        this.claimDto.isLocked = true;
        this.showSuccess = true;
      }
    });
  }

  markTestData() {
    this.isBusyTestData = true;
    this.setIsClaimTestDataService.setIsClaimTestData(this.claimDto.claimId, true).subscribe({
      next: () => {
        this.activeModal.close();
      }
    });
  }

  returnToClaimsList(): void {
    this.activeModal.close();
    this.router.navigate(['/adjuster/claim-list']).then();
  }
  
}
